/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';

const firebaseConfig = {
  apiKey: 'AIzaSyDuJ2TfqoS0OHKKTKX05kE6ZL_s7JGiXAM',
  authDomain: 'winerp-pos.firebaseapp.com',
  databaseURL: 'https://winerp-pos-default-rtdb.asia-southeast1.firebasedatabase.app',
  projectId: 'winerp-pos',
  storageBucket: 'winerp-pos.appspot.com',
  messagingSenderId: '971828547708',
  appId: '1:971828547708:web:36f91391481a69519439f9',
  measurementId: 'G-X2VTS9MP5K',
};

const app = initializeApp(firebaseConfig);
const db = getDatabase(app);

export default db;
